export default {
  banksPage: {
    nothingFound: 'Nothing found. Please check your entries.',
    bankInCountry: 'Choose your bank in '
  }
}
